if (process.env.VUE_APP_BRAND === 'BK') {
    module.exports = {
        colors: {
            Primary:    '#00476b',
            Secondary:  '#009bea',
            Tertiary:   '#eac300',
            Light:      '#f2f2f2',
            Dark:       '#003651',
            White:      '#ffffff',
            LightGrey:  '#d3d3d3',
            DarkGrey:   '#808080',
            Black:      '#000000',
            Green:      '#a4e408',
            Red:        '#e70407',
            
            MenuBg:    '#00476b',
            MenuText:  '#ffffff',
        },
        brand: 'BK',
        showLogin: false,
        showWelcome: false,
        initialCompany: '',
        logo: '',
        cards: ['valuation'],
        templates: ['company', 'competitors', 'valuation', 'yearreview'],
    };
} 

if (process.env.VUE_APP_BRAND === 'GT') {
    module.exports = {
        colors: {
            Primary:    '#4f2d7f',
            Secondary:  '#00a7b5',
            Tertiary:   '#ff7d1e',
            Light:      '#f2f2f2',
            Dark:       '#3a1967',
            White:      '#ffffff',
            LightGrey:  '#d3d3d3',
            DarkGrey:   '#808080',
            Black:      '#000000',
            Green:      '#9bd732',
            Red:        '#de002e',

            MenuBg:    '#ffffff',
            MenuText:  '#3a1967',
        },
        brand: 'GT',
        showLogin: false,
        showWelcome: true,
        initialCompany: '556356-9382',
        logo: '/static/gt/image/GT_logo-Outline_WHITE.svg',
        cards: [''],
        templates: ['company', 'competitors', 'closingmeeting', 'preclosingmeeting', 'futuremeeting', 'yearendmeeting'],
    };    
}
